// extracted by mini-css-extract-plugin
export default {"container":"CardProductContainer2_container__LYes6","wrapCards":"CardProductContainer2_wrapCards__O9SJO"};